function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
  fill: "#6c533a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m393.21875 155.472656-98.457031-98.457031-20.367188 20.367187-20.382812-20.382812-20.566407 20.566406 20.382813 20.382813-3.78125 3.78125.347656.347656-37.207031 37.207031 45.941406 45.941406-179.128906 179.128907 145.871094 145.871093c9.882812 1.160157 19.933594 1.773438 30.128906 1.773438 141.386719 0 256-114.613281 256-256 0-4.910156-.152344-9.789062-.425781-14.632812l-102.125-102.125zm0 0",
  fill: "#593927"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m254 159.632812-40.78125 204.585938 194.390625-20.390625v-50.976563c0-36.226562-12.988281-69.640624-36.574219-94.070312-24.375-25.25-58.691406-39.148438-96.644531-39.148438zm0 0",
  fill: "#d95d27"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m254 159.632812v204.585938l-153.609375-20.390625v-50.976563c0-36.226562 12.988281-69.640624 36.574219-94.070312 24.375-25.25 58.691406-39.148438 96.644531-39.148438zm0 0",
  fill: "#eb7330"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m387.21875 364.21875v-71.367188c0-30.921874-10.957031-59.296874-30.851562-79.90625-20.496094-21.230468-49.605469-32.921874-81.976563-32.921874h-20.390625l-20.390625 184.195312zm0 0",
  fill: "#c7461f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m120.78125 364.21875v-71.367188c0-30.921874 10.957031-59.296874 30.851562-79.90625 20.496094-21.230468 49.605469-32.921874 81.976563-32.921874h20.390625v184.195312zm0 0",
  fill: "#d95d27"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m406.535156 358.585938-23.210937 46.414062h-129.324219l-40.78125-46.414062zm0 0",
  fill: "#e3c281"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m254 358.585938v46.414062h-129.324219l-23.210937-46.414062zm0 0",
  fill: "#fedd90"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m254 360.59375-174-16.765625v-19.484375c0-23.984375 19.515625-43.5 43.5-43.5 3.375 0 6.746094.398438 10.03125 1.175781 10.082031-14.175781 26.59375-22.925781 44.34375-22.925781 26.816406 0 49.164062 19.519531 53.582031 45.09375 13.070313 4.257812 22.542969 16.558594 22.542969 31.03125zm0 0",
  fill: "#bfb053"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m123.335938 323.4375h20.390624v30.585938h-20.390624zm0 0",
  fill: "#8a8a47"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m167.535156 323.4375h20.394532v30.585938h-20.394532zm0 0",
  fill: "#8a8a47"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m428 343.828125v20.390625h-174l-25.953125-10.195312 25.953125-10.195313zm0 0",
  fill: "#fedd90"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m80 343.828125h174v20.390625h-174zm0 0",
  fill: "#fff2a3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m375.726562 260.765625 11.535157-80.785156-80.785157 11.535156c-12.644531 1.808594-24.832031 7.574219-34.558593 17.300781-23.890625 23.886719-23.890625 62.621094 0 86.507813 23.886719 23.890625 62.621093 23.890625 86.507812 0 9.726563-9.726563 15.496094-21.914063 17.300781-34.558594zm0 0",
  fill: "#eb7330"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m233.609375 139.242188h-20.390625c0-22.949219 5.980469-35.011719 11.257812-45.652344 4.898438-9.882813 9.132813-18.417969 9.132813-36.589844h20.390625c0 22.949219-5.980469 35.007812-11.257812 45.648438-4.898438 9.886718-9.132813 18.421874-9.132813 36.59375zm0 0",
  fill: "#fedd90"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m274.390625 139.242188h-20.390625c0-22.949219 5.980469-35.011719 11.257812-45.652344 4.898438-9.882813 9.132813-18.417969 9.132813-36.589844h20.390625c0 22.949219-5.980469 35.007812-11.257812 45.648438-4.902344 9.886718-9.132813 18.421874-9.132813 36.59375zm0 0",
  fill: "#fedd90"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m409.359375 157.882812v-18.640624h-20.390625v24.613281l-18.15625 18.15625 14.335938 14.5 18.238281-18.238281h24.613281v-20.390626zm0 0",
  fill: "#fff2a3"
});

var SvgChicken = function SvgChicken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChicken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chicken.8a42d8c4.svg";
export { ForwardRef as ReactComponent };